import React, { useState, useEffect } from 'react';

import Login from './Components/Login';
import Navbar from './Components/Navbar';
import MainPage from './Components/MainPage';
import CustomerScopeForm from './Components/CustomerScopeForm';
import { StyleProvider, Toast } from '@attentive-platform/stem-ui';
import { isBeamUser } from './Utils/HelperFunctions';

const isPublicScopeForm = () => window.location.pathname.startsWith('/scope-form/');

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    try {
      const storedToken = localStorage.getItem('authToken');
      setIsLoggedIn(!!storedToken);
    } catch {
      // Site data blocked — treat as logged out.
      setIsLoggedIn(false);
    }
  }, []);

  useEffect(() => {
    if (!isPublicScopeForm()) return undefined;
    const previous = document.title;
    document.title = 'Customer Scope Form';
    return () => {
      document.title = previous;
    };
  }, []);

  if (isPublicScopeForm()) {
    return (
      <div>
        <StyleProvider theme='default'>
          <Toast newestOnTop={false} limit={1} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <CustomerScopeForm />
        </StyleProvider>
      </div>
    );
  }

  return (
    <div>
      <StyleProvider theme={isBeamUser() ? 'default' : 'attentive-internal'}>
        <Toast newestOnTop={false} limit={1} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />

        {!isLoggedIn ? <Login setIsLoggedIn={setIsLoggedIn} /> : <MainPage />}
      </StyleProvider>
    </div>
  );
}

export default App;
